import { useCallback, useEffect, useState } from 'react';
import { onAuthStateChanged, signInWithEmailAndPassword, signOut } from 'firebase/auth';
import { auth } from '../firebase';

function useWorkspaceAuth() {
  const [user, setUser] = useState(null);
  const [isAuthLoading, setIsAuthLoading] = useState(process.env.NODE_ENV !== 'test');
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [authError, setAuthError] = useState('');

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, (nextUser) => {
      setUser(nextUser);
      setIsAuthLoading(false);
    });

    return () => {
      if (typeof unsub === 'function') unsub();
    };
  }, []);

  const handleAuth = useCallback(
    async (event) => {
      event.preventDefault();
      setAuthError('');

      try {
        const normalizedInput = username.trim().toLowerCase();
        const isEmail = normalizedInput.includes('@');

        if (isEmail && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(normalizedInput)) {
          setAuthError('Enter a valid email address.');
          return;
        }

        if (!isEmail && !/^[a-z0-9._-]{3,30}$/.test(normalizedInput)) {
          setAuthError('Username must be 3-30 chars: letters, numbers, dot, underscore, dash.');
          return;
        }

        const loginEmail = isEmail ? normalizedInput : `${normalizedInput}@euzlab.com`;
        await signInWithEmailAndPassword(auth, loginEmail, password);
        setUsername('');
        setPassword('');
      } catch (error) {
        setAuthError(error.message || 'Authentication failed.');
      }
    },
    [password, username]
  );

  const handleSignOut = useCallback(async () => {
    await signOut(auth);
  }, []);

  return {
    user,
    isAuthLoading,
    username,
    password,
    authError,
    setUsername,
    setPassword,
    handleAuth,
    handleSignOut
  };
}

export default useWorkspaceAuth;
